import { func, string, bool } from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import styles from './ProductTitle.css';

const cx = classNames.bind(styles);

const ProductTitle = ({ onProductClick, prefix, productUrl, title, sponsoredProduct }) => {
    const Title = () => {
        const cardTitleClasses = `${dt([
            'font-sans',
            'font-semibold',
            'overflow-hidden',
            'text-black',
            'text-small',
        ])} ${cx('title')}`;

        const titlePrefix = prefix ? (
            <span className={dt(['text-brand-red', 'leading-5'])}>{prefix} </span>
        ) : null;

        return productUrl ? (
            <a
                className={cardTitleClasses}
                data-automation-id="product-title"
                href={productUrl}
                onClick={(event) => {
                    onProductClick(event, 'title');
                }}
                title={title}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...(sponsoredProduct && { rel: 'sponsored' })}
            >
                {titlePrefix}
                {title}
            </a>
        ) : (
            <div className={cardTitleClasses} data-automation-id="product-title">
                {titlePrefix}
                {title}
            </div>
        );
    };

    return title ? <Title /> : null;
};

ProductTitle.defaultProps = {
    onProductClick: () => {},
    prefix: '',
    productUrl: '',
    title: '',
    sponsoredProduct: false,
};

ProductTitle.propTypes = {
    onProductClick: func,
    prefix: string,
    productUrl: string,
    title: string,
    sponsoredProduct: bool,
};

export default ProductTitle;
